<template>
    <BModal
        id="users-modal"
        v-model="showUserSel"
        :no-close-on-backdrop="true"
        dialog-class="modal-dialog-left modal-lg"
        body-class="p-3"
        size="xl"
    >
        <template #header>
            <h2 class="m-0">
                Вибір <span class="fw-300">{{ name_sel }}</span>
                <span class="ms-2">Вибрано: {{ selected }}</span>
            </h2>
            <div class="panel-toolbar pr-3 pb-2 align-self-end">
                <button
                    class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed"
                    @click="showUserSel = false"
                >
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </template>
        
        <BTable
            :items="filtered"
            :fields="fields"
            :primary-key="'user_id'"
            :current-page="currentPage"
            :per-page="perPage"
            show-empty
            :tbody-tr-class="tbodyRowClass"
            @row-clicked="rowClicked"
        >
            <!-- В bootstrap-vue-next нужен слот thead-top -->
            <template #thead-top="{ fields }">
                <tr>
                    <th v-for="field in fields" :key="field.key">
                        <div    v-if="field.key === 'selected'">
                        
                        </div>
                        <!--
                        <yes_no
                            @update:modelValue="setSelectedFilter"
                            v-if="field.key === 'selected'"
                            v-model="tickBoxChecked"
                            base_class="mb-0"
                            title="Лише обрані"
                        >
                        </yes_no>
                        -->
                        <!--
                        <BFormCheckbox
                            v-if="field.key === 'selected'"
                            v-model="tickBoxChecked"
                            @change="setSelectedFilter"
                            switch
                            size="sm"
                        >
                            Лише обрані
                        </BFormCheckbox>
                        -->
                        
                        <BFormInput
                            v-else-if="fieldIsFiltered(field)"
                            v-model="filters[field.key]"
                            :placeholder="field.label"
                            size="sm"
                        />
                    </th>
                </tr>
            </template>
            
            <!-- колонка выбранности -->
            <template #cell(selected)="{rowSelected}">
                <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                </template>
                <!-- <BFormCheckbox v-model="item[key]" @click.stop /> -->
            </template>
        </BTable>
        
        <BPagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-2"
        />
        
        <template #footer>
            <BButton
                variant="outline-primary"
                class="btn btn-lg waves-effect waves-themed me-3"
                @click.prevent="selectUserSel"
            >
                <i class="fal fa-check me-1" />
                Додати
            </BButton>
            
            <BButton
                variant="outline-warning"
                class="btn btn-lg waves-effect waves-themed"
                @click="showUserSel = false"
            >
                <i class="fal fa-times me-1" />
                Закрити
            </BButton>
        </template>
    </BModal>
</template>

<script>
import {
    BModal,
    BTable,
    BPagination,
    BFormInput,
    BFormCheckbox,
    BButton
} from 'bootstrap-vue-next'
import Yes_no from "../../../../base/yes_no.vue";

export default {
    name: 'usersel',
    emits: ['users_selected'],
    
    props: {
        id: { type: [String, Number], default: '' },
        name_: { type: String, default: '' },
        users: { type: Array, default: () => [] }
    },
    
    components: {
        Yes_no,
        BModal,
        BTable,
        BPagination,
        BFormInput,
        BFormCheckbox,
        BButton
    },
    
    data () {
        return {
            tickBoxChecked: false,
            showUserSel: false,
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            name_sel: '',
            items: [],
            fields: [
                { key: 'selected', label: '' },
                { key: 'contact_name', label: 'Користувач', sortable: true },
                { key: 'company', label: 'Організація', sortable: true },
                { key: 'email', label: 'E-mail', sortable: true },
                { key: 'contact_tel', label: 'Телефон', sortable: true },
                {
                    key: 'subscription_deactivated',
                    label: 'Відключена розсилка',
                    sortable: true,
                    formatter: (value) => (String(value) === '1' ? 'Відключена розсилка' : '')
                }
            ],
            filters: {
                selected: '',
                contact_name: '',
                company: '',
                email: '',
                contact_tel: ''
            }
        }
    },
    
    mounted () {
        this.loadusers()
        this.name_sel = this.name_
    },
    
    created () {
        EventBus.$on('choose_contragents', this.show)
    },
    
    methods: {
        show () {
            this.showUserSel = true
        },
        
        setSelectedFilter () {
            this.filters.selected = this.tickBoxChecked ? true : '';
            if (this.tickBoxChecked) this.currentPage = 1
        },
        
        fieldIsFiltered (field) {
            return Object.prototype.hasOwnProperty.call(this.filters, field.key)
        },
        
        tbodyRowClass (item) {
            if (!item) return
            return item.selected
                ? ['b-table-row-selected', 'table-primary', 'cursor-pointer']
                : ['cursor-pointer']
        },
        
        rowClicked (item, index, event) {
            if (event?.target?.closest('input[type="checkbox"]')) return
            item.selected = !item.selected
        },
        async loadusers () {
            console.log(this.selected_ids);
            
            try {
                const { data } = await axios.post('/internal/api/getUsersList')
                
                this.items = []
                if (data?.status === 'operation_success' && Array.isArray(data.data)) {
                    this.items = data.data.map(item => {
                        item.user_id = parseInt(item.user_id);
                        item.selected = this.selected_ids.includes(item.user_id);
                        
                        return item;
                    });
                    
                    
                    this.totalRows = this.items.length
                }
            } catch (e) {
                this.items = []
            }
        },
        
        selectUserSel () {
            const ids = this.items.filter(i => i.selected).map(i => i.user_id)
            const users = this.items.filter(i => i.selected);
            
            this.$emit('users_selected', { users_ids: ids,users : users })
            this.showUserSel = false
        }
    },
    
    computed: {
        selected () {
            return this.items.filter(i => i.selected).length
        },
        
        filtered () {
            if (!this.items.length) return []
            
            const hasText = (val, needle) =>
                String(val ?? '').toLowerCase().includes(String(needle ?? '').toLowerCase())
            
            const out = this.items.filter(item => {
                if (this.filters.selected === true && !item.selected) return false
                return ['contact_name', 'company', 'email', 'contact_tel'].every(k =>
                    hasText(item[k], this.filters[k])
                )
            })
            
            this.totalRows = out.length || this.items.length
            this.perPage = Math.min(this.totalRows, 15)
            
            if (!out.length) {
                return [
                    Object.keys(this.items[0]).reduce((obj, k) => ((obj[k] = ''), obj), {})
                ]
            }
            return out
        },
        
        selected_ids() {
            return this.users.map(x => {
                return parseInt(x.user_id);
            })
        },
    }
}
</script>

<style scoped>
/* при желании — косметика */
</style>
